var staticDayTime = 86400000

module.exports = staticDayTime



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/staticDayTime.js
// module id = 174
// module chunks = 75